import React, { useRef, useState, useEffect } from 'react';
import classnames from 'classnames';
import CloseIcon from '../../../Icons/CloseBold';
import CollectionPanel from '../../../CollectionPanel';
import IconButton from '../../../Button/IconButton';
import { IconSize } from '../../../Icons/IconWrap';
import AddToGroupsPanel from '../../../AddToGroupsPanel';
import { BiLoggerContextProvider } from '../../../biLogger';
import { useKeyDown } from '../../../utils/hooks/useKeyDown';
import CommentBoxPanel from '../CommentBoxPanel';
import { useCustomTransitionEvents } from './useCustomTransitionEvents';
import s from './PanelPopup.scss';
import { useFlag } from '../../../redux/flags/hooks/useFlag';
var PanelPopup = function (_a) {
    var visiblePanel = _a.visiblePanel, deviation = _a.deviation, className = _a.className, onClose = _a.onClose;
    var isVisible = !!visiblePanel;
    var rootRef = useRef(null);
    var _b = useState(isVisible), isOpen = _b[0], setIsOpen = _b[1];
    var shouldUseUpdatedStyles = useFlag('redesigned_comment_box_panel');
    useKeyDown(isVisible ? { Esc: onClose, Escape: onClose } : {});
    var _c = useCustomTransitionEvents(rootRef, isVisible, visiblePanel), openAnimationEvent = _c.openAnimationEvent, closeAnimationEvent = _c.closeAnimationEvent, closeEvent = _c.closeEvent;
    useEffect(function () {
        var onPanelOpen = function () { return setIsOpen(true); };
        var onPanelClose = function () { return setIsOpen(false); };
        openAnimationEvent.addListener(onPanelOpen);
        closeEvent.addListener(onPanelClose);
        return function () {
            openAnimationEvent.removeListener(onPanelOpen);
            closeEvent.removeListener(onPanelClose);
        };
    }, [closeEvent, openAnimationEvent]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: rootRef, className: classnames(s['root'], isVisible && s['visible'], isVisible && isOpen && s['open'], visiblePanel && s[visiblePanel], shouldUseUpdatedStyles && s['updated'], s['uplifted'], className) },
            visiblePanel === 'groups' && isVisible && (React.createElement(IconButton, { className: s['close'], onClick: onClose },
                React.createElement(CloseIcon, { size: IconSize.MEDIUM }))),
            React.createElement("div", { className: s['panel'] },
                visiblePanel === 'collection' && (React.createElement(CollectionPanel, { collectibleDeviation: deviation })),
                visiblePanel === 'groups' && (React.createElement(BiLoggerContextProvider, { value: { deviationid: deviation.deviationId } },
                    React.createElement(AddToGroupsPanel, { deviation: deviation }))),
                visiblePanel === 'comment' && (React.createElement(CommentBoxPanel, { panelOpenEvent: openAnimationEvent, panelCloseEvent: closeAnimationEvent, deviation: deviation, onClose: onClose }))))));
};
PanelPopup.displayName = 'PanelPopup';
export default PanelPopup;
//# sourceMappingURL=PanelPopup.actionbar_phase_2.js.map